<template>
  <div id="Index">
    <div class="posi">
      <div id="mark">
        <div class="left_nav">
          <div style="border-radius: 8px 8px 0 0;">
            <div>
              <h2>
                <a href="/list.html#/f3fd3027-8bde-492c-9827-eb8b66dbdad5" target="_blank">碳带</a>
              </h2>
              <a href="/list.html#/f8b5ee6c-41af-4329-97e8-069959155590" target="_blank">蜡基碳带</a>
              <a href="/list.html#/e7a45678-de4f-4c41-93a4-ed93be3a626d" target="_blank">树脂基碳带</a>
            </div>
          </div>
          <div>
            <div>
              <h2>
                <a href="/list.html#/ee2a6b7b-9d37-4df3-8c38-4e26ca87cf67" target="_blank">标签标牌</a>
              </h2>
              <a href="/list.html#/4accce19-8bc6-40e6-b994-f5923ae184aa" target="_blank">纸质标签</a>
              <a href="/list.html#/a957c844-43ba-47c8-b3d6-dc46c93c3f3d" target="_blank">合成材料标签</a>
            </div>
          </div>
          <div>
            <div>
              <h2>
                <a href="/list.html#/b89dfd80-347e-4490-a09d-3f48071c9199" target="_blank">证卡打印机耗材</a>
              </h2>
              <a href="/list.html#/ffd9a1f1-d15d-4611-9599-9fad0de370b4" target="_blank">证卡打印机色带</a>
              <a href="/list.html#/e55e3d56-f155-4826-9f5d-2ec8df340be2" target="_blank">证卡</a>
            </div>
          </div>
          <div >
            <div>
              <h2>
                <a href="/list.html#/e32b4cfb-b45c-426e-9f9b-651bf412e17e" target="_blank">移动数据终端</a>
              </h2>
              <a href="/list.html#/0d6e946b-5cc0-40bd-b76e-48a99026be67" target="_blank">手持式数据终端</a>
              <a href="/list.html#/c55d40a1-2370-4b13-9270-cd12e5dbb35d" target="_blank">平板电脑</a>
            </div>
          </div>
          <div>
            <div>
              <h2>
                <a href="/list.html#/e49b53cf-0c1c-4494-967a-d125d2d322f0" target="_blank">标签打印机</a>
              </h2>
              <a href="/list.html#/b4b7aec4-48f4-4aad-9a8b-50bb5a3c65e4" target="_blank">桌面打印机</a>
              <a href="/list.html#/57de034e-12ff-46be-8f25-f34cc3e135d7" target="_blank">工业打印机</a>
            </div>
          </div>
          <div style="border-radius:0 0 8px 8px;">
            <div style="border-bottom:none;">
              <h2>
                <a href="/list.html#/761f26d0-071f-4400-bc02-46edfe892a79" target="_blank">条码扫描器</a>
              </h2>
              <a href="/list.html#/065e9e82-5d54-4ee5-8931-e16c4b9540d4" target="_blank">通用扫描器</a>
              <a href="/list.html#/8902c256-ee4e-491f-a5a6-79e018a89880" target="_blank">耐用型扫描器</a>
            </div>
          </div>
        </div>
        <div class="right_nav" />
      </div>
    </div>

    <div class="banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(bannerItem, bannerKey) in bannerList" :key="bannerKey" class="swiper-slide">
            <a :href="bannerItem['bannerLink']" target="_blank"><img :src="bannerItem['bannerPath']" :alt="bannerItem['bannerName']"></a>
          </div>
        </div>
        <!-- <div class="show_span">
          <span></span>
        </div> -->
      </div>
    </div>

    <div id="cp_play">
      <div>
        <a href="/list.html#/f3fd3027-8bde-492c-9827-eb8b66dbdad5" >
          <img src="~@/assets/images/d1e366dbcf4311e7ee9e15c5b94553e.jpg" alt="">
        </a>
      </div>
      <div>
        <a href="/list.html#/ee2a6b7b-9d37-4df3-8c38-4e26ca87cf67" >
          <img src="~@/assets/images/402dae96621c694ba4762c0cfa9304f.jpg" alt="">
        </a>
      </div>
      <div>
        <a href="/list.html#/42f15cf1-76ec-493b-b6eb-29fc520539cd" >
          <img src="~@/assets/images/2bd29461d2648135a08049fbb0dbf22.jpg" alt="">
        </a>
      </div>
      <div style="margin-right: 0px;">
        <a href="/list.html#/42f15cf1-76ec-493b-b6eb-29fc520539cd" >
          <img src="~@/assets/images/dfe678e1923d3733b2eb718cb47b846.jpg" alt="">
        </a>
      </div>
    </div>
    <div id="cp_now">
      <h2>热销单品</h2>
      <div class="cp_now_div">
        <div class="cp_now_div_1">
          <a href="/list.html#/060bc9f4-7e2e-4a3d-8c0c-e6893204bb1e" target="_blank">
            <img src="~@/assets/images/4cbc9104b4c0904ced7ee7873831cb2.jpg" alt="热销单品">
          </a>
        </div>
        <div class="cp_now_div_2">
          <a v-for="(showItem, showKey) in hotSeeList" :key="showKey" :href="`/product.html#/${showItem['proSn']}`" target="_blank">
            <div>
              <img :src="showItem['proImg']" :alt="showItem['proName']">
              <h6 :title="showItem['proName']">{{ showItem['proName'] }}</h6>
              <p :title="showItem['proTip']">{{ showItem['proTip'] }}</p>
              <span>¥ {{ showItem['shopPrice'] | parseToMoney }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="man_banner">
      <h2>精品推荐</h2>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(hotitem, hotKey) in hotList" :key="hotKey" class="swiper-slide">
            <a :href="`/product.html#/${hotitem['proSn']}`" class="border_pasen" target="_blank">
              <div class="border_pasen_img">
                <img :src="hotitem['proImg']" :alt="hotitem['proName']">
                <div>
                  {{ hotitem['proTip'] ? hotitem['proTip'].substr(0, 15) : '' }}
                </div>
                <p>{{ hotitem['proName'] }}</p>
                <span>¥ {{ hotitem['shopPrice'] | parseToMoney }}</span>
              </div>
            </a>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination" />
        <!-- Add Arrows -->
        <div class="swiper-button-next" />
        <div class="swiper-button-prev" />
      </div>
    </div>
    <div class="btm_banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(ad1Item, ad1Key) in ads1" :key="ad1Key" class="swiper-slide">
            <a :href="ad1Item['adLink']" target="_blank">
              <img :src="ad1Item['adPath']" :alt="ad1Item['adName']">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapState } from 'vuex'
import Swiper from 'swiper'
import { Loading } from 'element-ui'
const { BANNERS_GET, VARS: VARS_BANNER } = require('@/api/design/banner')
const { ADS_GET, VARS: VARS_AD } = require('@/api/design/ad')
const { PROS_GET } = require('@/api/mall/product')

export default {
  name: 'Index',
  data() {
    return {
      VARS_BANNER,
      VARS_AD,
      // banner图
      bannerList: [],
      // 精品推荐
      hotList: [],
      // 广告ad1
      ads1: null,
      // 热门点击数
      hotSeeList: []
    }
  },
  mounted() {
    // banner
    this.bannersGet()
    // 热销加载
    this.hotSeeGet()
    // 热门产品
    this.hotListGet()
    // 广告
    this.ad1Get()
  },
  methods: {
    // 加载首页banner
    bannersGet() {
      const dataLoading = Loading.service({
        lock: true, text: `加载中...`, target: document.querySelector('.banner')
      })
      BANNERS_GET({ portal: this.VARS_BANNER.PORTAL.WEB.value, num: 10 }).then(res => {
        this.bannerList = res.data
        this.$nextTick(() => {
          this.startBanner()
        })
        dataLoading.close()
      }).catch(e => {
        console.log(e)
        dataLoading.close()
      })
    },
    // 热销加载
    hotSeeGet() {
      const dataLoading = Loading.service({
        lock: true, text: `加载中...`, target: document.querySelector('.cp_now')
      })
      PROS_GET({ sortProp: 'saleNum', num: 8, page: 1 }).then(res => {
        this.hotSeeList = res.data.rows
        dataLoading.close()
      }).catch(e => {
        this.hotSeeList = []
        console.log('err:', e)
        dataLoading.close()
      })
    },
    // 精品推荐（热门产品）
    hotListGet() {
      const dataLoading = Loading.service({
        lock: true, text: `加载中...`, target: document.querySelector('.man_banner')
      })
      PROS_GET({ sortProp: 'visitNum', num: 10, page: 1 }).then(res => {
        this.hotList = res.data.rows
        this.$nextTick(() => {
          this.startHoter()
        })
        dataLoading.close()
      }).catch(e => {
        this.hotSeeList = []
        console.log('err:', e)
        dataLoading.close()
      })
    },

    // 获取横条广告
    ad1Get() {
      const dataLoading = Loading.service({
        lock: true, text: `加载中...`, target: document.querySelector('.btm_banner')
      })
      ADS_GET({ portal: this.VARS_AD.PORTAL.WEB.value, num: 3 }).then(res => {
        this.ads1 = res.data
        this.$nextTick(() => {
          this.startAds1()
        })
        dataLoading.close()
      }).catch(e => {
        this.ads1 = null
        console.log('err:', e)
        dataLoading.close()
      })
    },
    // 产品推荐 swiper
    startBanner() {
      new Swiper('.banner>.swiper-container', {
        width: 1920,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        }
      })
    },

    startHoter() {
      new Swiper('.man_banner>.swiper-container', {
        slidesPerView: 5,
        slidesPerGroup: 5,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        }
      })
    },

    startAds1() {
      new Swiper('.btm_banner>.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  @import 'swiper/dist/css/swiper.css';
  #Index {
    overflow: hidden;
    & > .posi {
      width: 1200px;
      height: auto;
      margin: 0 auto;

      & > #mark {
        width: auto;
        height: auto;
        margin: 0 auto;
        position: absolute;
        z-index: 2;
        top: 150px;

        & > .left_nav {
          width: 220px;
          height: 440px;
          float: left;
          border-radius: 8px;
          background: #f6f6f6;
          box-shadow: 0 0 2px #ddd;

          & > div {
            width: 100%;
            height: 73px;

            & > div {
              width: 170px;
              height: 73px;
              margin: 0 auto;
              border-bottom: 1px #e6e6e6 solid;

              & > a {
                color: #999;
                font-size: 14px;
                text-decoration: none;
              }

              & > h2 {
                & > a {
                  color: #333;
                  font-weight: normal;
                  font-size: 16px;
                  text-decoration: none;
                  line-height: 40px;
                  display: block;
                }
              }
            }
          }

          & > div:hover {
            background: #fff;
            // box-shadow: 3px 0 3px 0 #ccc;
          }
        }
        & > .right_nav {
          width: 400px;
          height: 440px;
          background: red;
          border-radius: 0 20px 20px 0;
          float: left;
          display: none;
        }
      }
    }
    & > .banner {
      width: 1200px;;
      height: auto;
      //overflow: hidden;
      position: relative;
      height:550px;
      margin:0 auto;

      & > .swiper-container {
        margin-left:-360px;
        width:1920px;

        & > .swiper-wrapper {
          & > .swiper-slide {
            & > a {
              display: block;
              overflow: hidden;

              & > img {
                width: 1920px;
                display: block;
                height: 550px;
                margin: 0 auto;
              }
            }
          }
        }
        & > .show_span {
          width: 100%;
          min-width: 1200px;
          height: 72px;
          display: block;
          position: absolute;
          bottom: 0;
          z-index: 2;

          & > span {
            background: url(~@/assets/images/bg-slide.png) center center no-repeat;
            width: 100%;
            background-size: 100% 72px;
            min-width: 1200px;
            height: 72px;
            display: block;
          }
        }
      }
    }
    & > #fourmin {
      width: 1200px;
      height: auto;
      margin: 0 auto;

      & > .fourmin {
        width: 1200px;
        height: 88px;
        position: absolute;
        z-index: 999;
        top: 610px;
        background-color: #fff;
        box-shadow: darkgrey 5px 5px 15px 3px;
        border-radius: 15px;

        & > .fourmin_1 {
          width: 270px;
          height: 88px;
          float: left;
          border-radius: 15px 0 0 15px;

          & > .fourmin_1_img {
            width: 50px;
            height: 50px;
            float: left;
            margin: 19px 0 0 19px;

            & > img {
              width: 50px;
              height: 50px;
            }
          }

          & > .fourmin_1_use {
            width: 175px;
            height: 55px;
            float: left;
            border-right: 1px #eeeeee solid;
            margin-left: 25px;
            margin-top: 16.5px;

            & > .fourmin_1_use1 {
              color: #666;
              font-size: 12px;

              & > a {
                text-decoration: none;
                color: #000;
                font-size: 14px;
              }
            }

            & > .fourmin_1_use2 {
              margin-top: 10px;

              & > .fourmin_1_use2_newsman {
                width: 67px;
                height: 21px;
                display: block;
                font-size: 14px;
                border-radius: 5px;
                float: left;
                border: 1px #de5b60 solid;
                text-decoration: none;
                text-align: center;
                color: #de5b60;
                background: #fff;
                line-height: 1.5;
              }

              & > .fourmin_1_use2_newsman:hover {
                background: #de5b60;
                color: #fff;
              }

              & > .fourmin_1_use2_vip {
                width: 67px;
                height: 21px;
                display: block;
                font-size: 14px;
                border-radius: 5px;
                float: left;
                border: 1px #595454 solid;
                text-decoration: none;
                text-align: center;
                color: #fde4b3;
                background: #595454;
                line-height: 1.5;
                margin-left: 10px;
              }

              & > .fourmin_1_use2_vip:hover {
                background: #000;
              }
            }
          }
        }

        & > .fourmin_2 {
          width: 660px;
          height: 88px;
          float: left;
          border-right: 1px #eeeeee solid;

          & > .fourmin_2_1 {
            width: 70px;
            height: 70px;
            float: left;
            margin-left: 34.28px;
            color: #666;
            font-size: 12px;
            text-align: center;
            margin-top: 9px;

            & > a {
              color: #666;
              font-size: 12px;
              text-align: center;
              text-decoration: none;

              & > div {
                & > img {
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }

          & > .fourmin_2_2 {
            width: 70px;
            height: 70px;
            float: left;
            margin-left: 34.28px;
            text-align: center;
            margin-top: 9px;

            & > a {
              color: #666;
              font-size: 12px;
              text-align: center;
              text-decoration: none;

              & > div {
                & > img {
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }

          & > .fourmin_2_3 {
            width: 70px;
            height: 70px;
            float: left;
            margin-left: 34.28px;
            color: #666;
            font-size: 12px;
            text-align: center;
            margin-top: 9px;

            & > a {
              color: #666;
              font-size: 12px;
              text-align: center;
              text-decoration: none;

              & > div {
                & > img {
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }

          & > .fourmin_2_4 {
            width: 70px;
            height: 70px;
            float: left;
            margin-left: 34.28px;
            color: #666;
            font-size: 12px;
            text-align: center;
            margin-top: 9px;

            & > a {
              color: #666;
              font-size: 12px;
              text-align: center;
              text-decoration: none;

              & > div {
                & > img {
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }

          & > .fourmin_2_5 {
            width: 70px;
            height: 70px;
            float: left;
            margin-left: 34.28px;
            color: #666;
            font-size: 12px;
            text-align: center;
            margin-top: 9px;

            & > a {
              color: #666;
              font-size: 12px;
              text-align: center;
              text-decoration: none;

              & > div {
                & > img {
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }

          & > .fourmin_2_6 {
            width: 70px;
            height: 70px;
            float: left;
            margin-left: 34.28px;
            color: #666;
            font-size: 12px;
            text-align: center;
            margin-top: 9px;

            & > a {
              color: #666;
              font-size: 12px;
              text-align: center;
              text-decoration: none;

              & > div {
                & > img {
                  width: 40px;
                  height: 40px;
                }
              }
            }
          }
        }

        & > .fourmin_3 {
          width: 269px;
          height: 88px;
          float: left;
          border-radius: 0 15px 15px 0;

          & > .fourmin_3_1 {
            width: 269px;
            height: 43.5px;
            border-bottom: 1px #eeeeee solid;

            & > span {
              width: 50px;
              height: 20px;
              display: block;
              float: left;
              margin: 11.25px 0 0 30px;
              font-size: 14px;
              color: #777777;
            }

            & > div {
              width: 150px;
              height: 20px;
              float: left;
              font-size: 12px;
              margin-top: 10px;
              color: #ccc;
            }
          }

          & > .fourmin_3_2 {
            width: 269px;
            height: 43.5px;

            & > div {
              width: 70px;
              height: 14px;
              float: left;
              margin: 10px 0 0 19.6px;

              & > a {
                font-size: 12px;
                text-decoration: none;
                color: #777;

                & > img {
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }
        }
      }
    }

    & > #cp_play {
      width: 1200px;
      height: 200px;
      margin: 20px auto 0 auto;
      & > div {
        width: 290px;
        height: 200px;
        float: left;
        margin-right: 13px;
        border-radius: 10px;
        & > a {
          & > img {
            width: 290px;
            height: 200px;
            border-radius: 8px;
          }
        }
      }
      & > div:hover {
        box-shadow: #f2f2f2 3px 3px 6px 3px;
      }
    }
    & > #cp_now {
      width: 1200px;
      margin: 30px auto 0 auto;
      // line-height: 3;

      & > h2 {
        font-weight: normal;
        font-size: 26px;
        margin: 0 auto 30px;
      }

      & > .cp_now_div {
        width: 1200px;
        height: 592px;
        margin: 0 auto;

        & > .cp_now_div_1 {
          width: 230px;
          height: 592px;
          float: left;
          border-radius: 10px;
          & > a {
            & > img {
              width: 230px;
              height: 592px;
              border-radius: 10px;
            }
          }
        }
        & > .cp_now_div_1:hover {
          box-shadow: #f2f2f2 3px 3px 6px 3px;
        }

        & > .cp_now_div_2 {
          width: 968px;
          height: 592px;
          float: left;
          & > a {
            width: 230px;
            height: 290px;
            display: block;
            float: left;
            background-color: #fff;
            border-radius: 10px;
            text-decoration: none;
            margin: 0 0 12px 12px;
            box-shadow: #f2f2f2 0px 0px 4px 3px;
            &:hover{
              box-shadow: #f2f2f2 3px 3px 6px 3px;
            }
            & > div {
              width: 150px;
              height: 230px;
              margin: 40px auto 0 auto;
              text-align: center;
              line-height: 2;
              & > img {
                width: 120px;
                height: auto;
              }
              & > h6{
                color: #000;
                font-size: 16px;
                max-height: 64px;
                overflow: hidden;
              }
              & > p {
                color: #666;
                font-size: 12px;
                line-height: 24px;
                height: 24px;
                overflow: hidden;
              }
              & > span {
                color: red;
              }
            }
          }
        }
      }
    }
    // 推荐
    &>.man_banner{
      width: 1200px;
      height: 360px;
      margin: 0 auto;
      & > .swiper-container{
        width: 100%;
        height: 316px;
        &>.swiper-wrapper{
          &>.swiper-slide {
            height: 316px;
            width: 230px;
            &>.border_pasen{
              display:block;
              height: 242px;
              width: 230px;
              background-color: #fff;
              border-radius: 10px;
              position: relative;
              text-align: center;
              cursor: pointer;
              text-decoration: none;
              color: #333;
              & > .border_pasen_img{
                width: 80%;
                height: 100%;
                margin: 0 auto;
                text-align: center;
                & > img{
                  width: 100%;
                  min-height: 184px;
                }
                & > div{
                  width: 100%;
                  height: 35px;
                  position: absolute;
                  background-color: #f3f3f3;
                  z-index:10;
                  bottom: 0px;
                  left: 0;
                  border-radius: 0 0 10px 10px;
                  font-size: 14px;
                  color: #777;
                  text-align: center;
                  line-height: 2.5;
                }
                &>p{
                  margin-top: 60px;
                  line-height:18px;
                  max-height:36px;
                  overflow:hidden;
                  font-size: 14px;
                }
                &>span{
                  color: red;
                  font-size: 13px;
                  height:16px;
                }
              }
            }
            &>.border_pasen:hover{
              box-shadow: #f2f2f2 3px 3px 6px 3px;
            }
          }
        }
      }
      & > h2{
        font-weight: normal;
        font-size: 26px;
        margin: 30px auto;
      }
    }
    // 广告
    &>.btm_banner{
      width: 1200px;
      height: 120px;
      margin: 30px auto;
      &>.swiper-container {
        width: 100%;
        height: 100%;
        &>.swiper-wrapper{
          &>.swiper-slide {
            text-align: center;
            font-size: 18px;
            background: #fff;
            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            &>img{
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index.vue